import React, { useState } from 'react';
import SalesOrderList from '../components/sales-order/SalesOrderList';
import SalesOrderForm from '../components/sales-order/SalesOrderForm';

const SalesOrder = () => {
    const [view, setView] = useState('list'); // 'list' or 'form'
    const [selectedOrder, setSelectedOrder] = useState(null);

    const handleCreateNew = () => {
        setSelectedOrder(null);
        setView('form');
    };

    const handleEditOrder = (order) => {
        setSelectedOrder(order);
        setView('form');
    };

    const handleBackToList = () => {
        setSelectedOrder(null);
        setView('list');
    };

    return (
        <div className="h-full ">
            {view === 'list' ? (
                <SalesOrderList
                    onCreateNew={handleCreateNew}
                    onEditOrder={handleEditOrder}
                />
            ) : (
                <SalesOrderForm
                    onBack={handleBackToList}
                    onCreateNew={handleCreateNew}
                    
                     orderDataId={selectedOrder?.soId}  
                />
            )}
        </div>
    );
};

export default SalesOrder;
